import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { ConfBigImgTitleTextComponent } from './Components/conf-big-img-title-text/conf-big-img-title-text.component';
import { ConfIconTextRectComponent } from './Components/conf-icon-text-rect/conf-icon-text-rect.component';
import { ConfIconTitleTextRectComponent } from './Components/conf-icon-title-text-rect/conf-icon-title-text-rect.component';
import { ConfImgTitleSqrComponent } from './Components/conf-img-title-sqr/conf-img-title-sqr.component';
import { ConfBaseVehicleCatalogComponent } from './Components/conf-base-vehicle-catalog/conf-base-vehicle-catalog.component';
import { ConfFooterComponent } from './Components/conf-footer/conf-footer.component';
import { ConfNavHeaderComponent } from './Components/conf-nav-header/conf-nav-header.component';
import { ConfProgressStepBarComponent } from './Components/conf-progress-step-bar/conf-progress-step-bar.component';
import { ConfStepCountComponent } from './Components/conf-step-count/conf-step-count.component';
import { ConfCarouselComponent } from './Components/conf-carousel/conf-carousel.component';
import { ConfCaroursalComponent } from './Components/conf-caroursal/conf-caroursal.component';
import { ConfPricebreakComponent } from './Components/conf-pricebreak/conf-pricebreak.component';
import { ConfVehicleinformationComponent } from './Components/conf-vehicleinformation/conf-vehicleinformation.component';
import { ConfVasComponent } from './Components/conf-vas/conf-vas.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ConfBigImgTitleDescComponent } from './Components/conf-big-img-title-desc/conf-big-img-title-desc.component';
import { ConfVasFirstPopupComponent } from './Components/conf-vas/conf-vas-first-popup/conf-vas-first-popup.component';
import { ConfVasSecondPopupComponent } from './Components/conf-vas/conf-vas-second-popup/conf-vas-second-popup.component';

import { CurrencyPipe } from './pipe/currency.pipe';
import { ConfVasKnowmorePopupComponent } from '../../configurator-app/Conf-Shared/Components/conf-vas/conf-vas-knowmore-popup/conf-vas-knowmore-popup.component';
import { ConfFullCircleCarouselComponent } from './Components/conf-full-circle-carousel/conf-full-circle-carousel.component';
import { ConfHalfCircleCarouselComponent } from './Components/conf-half-circle-carousel/conf-half-circle-carousel.component';
import { ConfSwiperCarouselComponent } from './Components/conf-swiper-carousel/conf-swiper-carousel.component';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SemiArcComponent } from './Components/semi-arc/semi-arc.component';
import { ResponsiveCarousalComponent } from './Components/responsive-carousal/responsive-carousal.component';
import { SnakecomponentComponent } from './Components/snakecomponent/snakecomponent.component';
import { ConfNavButtonPanelComponent } from './Components/conf-nav-button-panel/conf-nav-button-panel.component';
import { SnakeResponsiveComponent } from './Components/snake-responsive/snake-responsive.component';
import { OnroadPricePopupComponent } from './Components/conf-pricebreak/onroad-price-popup/onroad-price-popup.component';
import { FetchGrossPriceComponent } from './Components/conf-pricebreak/fetch-gross-price/fetch-gross-price.component';
import { PdfGeneratorComponent } from './Components/pdf-generator/pdf-generator.component';
import { BrtCalculatorPopupComponent } from './Components/conf-pricebreak/brt-calculator-popup/brt-calculator-popup.component';
import { BrtDetailsPopupComponent } from './Components/conf-pricebreak/brt-details-popup/brt-details-popup.component';

import { FormsModule } from '@angular/forms';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
@NgModule({
  declarations: [
    ConfIconTextRectComponent,
    ConfIconTitleTextRectComponent,
    ConfBigImgTitleTextComponent,
    ConfImgTitleSqrComponent,
    ConfBaseVehicleCatalogComponent,
    ConfFooterComponent,
    ConfNavHeaderComponent,
    ConfProgressStepBarComponent,
    ConfStepCountComponent,
    ConfCaroursalComponent,
    ConfPricebreakComponent,
    ConfVehicleinformationComponent,
    ConfVasComponent,
    ConfBigImgTitleDescComponent,
    ConfVasFirstPopupComponent,
    ConfVasSecondPopupComponent,
    CurrencyPipe,
    ConfVasKnowmorePopupComponent,
    ConfFullCircleCarouselComponent,
    ConfHalfCircleCarouselComponent,
    ConfSwiperCarouselComponent,
    SemiArcComponent,
    ResponsiveCarousalComponent,
    SnakecomponentComponent,
    ConfNavButtonPanelComponent,
    SnakeResponsiveComponent,
    OnroadPricePopupComponent,
    FetchGrossPriceComponent,
    PdfGeneratorComponent,
    BrtCalculatorPopupComponent,
    BrtDetailsPopupComponent,
    ConfCarouselComponent

  ],
  imports: [
    CommonModule,
    AutocompleteLibModule,
    NgCircleProgressModule.forRoot({}),
    MatDialogModule,
    MatButtonModule,
    MatExpansionModule,
    FormsModule,
    NgxSkeletonLoaderModule.forRoot()
  ],
  exports: [
    ConfIconTextRectComponent,
    AutocompleteLibModule,
    ConfIconTitleTextRectComponent,
    ConfBigImgTitleTextComponent,
    ConfImgTitleSqrComponent,
    ConfBaseVehicleCatalogComponent,
    ConfFooterComponent,
    ConfNavHeaderComponent,
    ConfProgressStepBarComponent,
    ConfStepCountComponent,
    ConfCaroursalComponent,
    ConfPricebreakComponent,
    ConfVehicleinformationComponent,
    ConfVasComponent,
    ConfBigImgTitleDescComponent,
    MatDialogModule,
    MatButtonModule,
    SemiArcComponent,
    ConfFullCircleCarouselComponent,
    ConfHalfCircleCarouselComponent,
    ConfSwiperCarouselComponent,
    ResponsiveCarousalComponent,
    SnakecomponentComponent,
    ConfNavButtonPanelComponent,
    SnakeResponsiveComponent,
    OnroadPricePopupComponent,
    FetchGrossPriceComponent,
    PdfGeneratorComponent,
    ConfCarouselComponent

  ]
})
export class ConfSharedModule { }
